import { Modal, ModalCloseButton, ModalContent, ModalHeading, ModalProps } from '@uikit';

import { CopyInput } from '@store:web/components/common/CopyInput';

import ShareSocialList, { ShareSocialListProps } from './ShareSocialList';

export type ShareModalProps = Omit<ModalProps, 'children'> &
  Pick<ShareSocialListProps, 'text' | 'title' | 'url'> & {
    heading: string;
  };

export default function ShareModal({ url, text, heading, title, ...props }: ShareModalProps) {
  return (
    <Modal {...props}>
      <ModalContent className="flex flex-col items-center p-0">
        <ModalCloseButton className="!m-4" />

        <div className="flex flex-col items-center gap-4 pt-0 px-4 sm:px-12 pb-6 sm:pb-12">
          <ModalHeading>{heading}</ModalHeading>

          <CopyInput url={url} />

          <ShareSocialList url={url} text={text} title={title} />
        </div>
      </ModalContent>
    </Modal>
  );
}
